const state = {
  lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'tr'
}

const mutations = {
  change_lang (state, lang) {
    state.lang = lang
    localStorage.setItem('lang', lang)
  },
  init_lang (state) {
    // Check if the ID exists
    if (localStorage.getItem('lang')) {
      state.lang = localStorage.getItem('lang')
      state.langPicture = localStorage.getItem('langPicture')
    } else {
      state.lang = (navigator.language || navigator.userLanguage).substr(0, 2)
    }
  }
}

const actions = {
  change_lang ({ commit }, lang) {
    commit('change_lang', lang)
  }
}

const getters = {
  lang () {
    return state.lang
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
